import React, { useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { connect } from 'react-redux';
import { 
    Flex, Text, IconButton, HStack, Image, VStack, useToast
} from '@chakra-ui/react';
import { FiMenu } from "react-icons/fi";
import { withNamespaces } from 'react-i18next';
import { setSidebarMobileOpen, clearGlobalErrorMsg } from '../../redux/actions';
import { getIsSidebarMobileOpen, getGlobalErrorMsg } from '../../redux/selectors';

function Header({ isSidebarMobileOpen, setSidebarMobileOpen, globalErrorMsg, clearGlobalErrorMsg, t }) {
    const [ cookies, setCookie, removeCookie ] = useCookies(["loginCookie", "selectedClinic"]);
    const toast = useToast();
    const LOGO_URL = cookies.selectedClinic?.data?.logo_url;
    const CLINIC_NAME = cookies.selectedClinic?.data?.name?.length > 0 ? cookies.selectedClinic?.data?.name : "ĐẶT LỊCH KHÁM";

    useEffect(() => {
        if(globalErrorMsg?.length > 0) {
            toast({
                id: "global-error-info",
                description: globalErrorMsg,
                status: "error",
                duration: 3000,
                isClosable: true,
                position: "bottom-right"
            });

            clearGlobalErrorMsg();
        }
    }, [globalErrorMsg]);

    return (
        <Flex flexDirection={{ base: "column", md: "column", lg: "row" }} bg="#FFFFFF" paddingLeft="1vw" py={2} align="center">
            <HStack w={{base: "100%", md: "40%", lg: "40%"}}>
                <MinimizeSideBar isSidebarMobileOpen={isSidebarMobileOpen} setSidebarMobileOpen={setSidebarMobileOpen}/>
                <Flex direction={{base: "column", md: "row", lg: "row"}} align="center">
                    {
                        LOGO_URL && 
                        <Image alt="logo" src={`${process.env.REACT_APP_UPLOADS_ENDPOINT_URL}/companies/${LOGO_URL}`} maxW="119px" maxH="79px"/>
                    }
                    <Text fontSize="24px" fontWeight="700" color="#FE8B39" ml={4} display={{ base: "none", md: "inherit", lg: "inherit" }}>
                        {CLINIC_NAME}
                    </Text>
                </Flex>
            </HStack>

            <VStack marginLeft="10vw" display={{ base: "none", md: "none", lg: "flex"}}>
                <HStack spacing={2}>
                    <Image alt="logo" src="/images/clinics/icons/phone.png" />
                    <Text color="#285430" fontWeight="600" textTransform="uppercase">{t("Emergency_Phone")}</Text>
                </HStack>
                <Text color="#FE8B39" fontWeight="600">{cookies.selectedClinic?.data?.alarm_phone}</Text>
            </VStack>

            <VStack marginLeft="4vw" display={{ base: "none", md: "none", lg: "flex"}}>
                <HStack spacing={2}>
                    <Image alt="logo" src="/images/clinics/icons/clock.png" />
                    <Text color="#285430" fontWeight="600" textTransform="uppercase">{t("Working_Hourly")}</Text>
                </HStack>
                <Text color="#FE8B39" fontWeight="600">{cookies.selectedClinic?.data?.work_time}</Text>
            </VStack>
            
            <VStack marginLeft="4vw" display={{ base: "none", md: "none", lg: "flex"}}>
                <HStack spacing={2}>
                    <Image alt="logo" src="/images/clinics/icons/location.png" />
                    <Text color="#285430" fontWeight="600" textTransform="uppercase">{t("Clinic_Address")}</Text>
                </HStack>
                <Text color="#FE8B39" fontWeight="600">{cookies.selectedClinic?.data?.address}</Text>
            </VStack>
        </Flex>
    )
}

function MinimizeSideBar({ isSidebarMobileOpen, setSidebarMobileOpen, ...rest }) {
    return (
        <Flex
            display={{ base: "flex", md: "none", lg: "none" }}
            ml={{ base: 0, md: 60 }}
            px="1"
            position="sticky"
            top="0"
            height="20"
            zIndex="1"
            alignItems="center"
            bg="white"
            justifyContent={{ base: "space-between", md: "flex-end" }}
            {...rest}
         >
            <IconButton
                display={{ base: "flex", md: "none" }}
                onClick={() => setSidebarMobileOpen(!isSidebarMobileOpen)}
                variant="outline"
                title="open menu"
                icon={<FiMenu />}
            />
        </Flex>
    )
}

const mapStateToProps = (state) => {
    const isSidebarMobileOpen   =           getIsSidebarMobileOpen(state);
    const globalErrorMsg        =           getGlobalErrorMsg(state);

    return { isSidebarMobileOpen,globalErrorMsg };
}

const mapDispatchToProps = (dispatch) => ({
    setSidebarMobileOpen:       payload => dispatch(setSidebarMobileOpen(payload)),
    clearGlobalErrorMsg:        payload => dispatch(clearGlobalErrorMsg(payload)),
})

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(Header));